
import md5 from "crypto-js/md5";

export const getGravatarUrl = (email) => {
  const hash = md5(email.trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?d=mp&r=g&s=200`;
};
